import React from 'react';
import { useSpinradContext } from '../context/SpinradContext';
import { BrandLogo, HdrLeft, HeaderBar, Pen, Tab, Tabs } from './styles';

const Header: React.FC = () => {
  const { currentView, switchView, cards } = useSpinradContext();

  return (
    <HeaderBar>
      <HdrLeft>
        <BrandLogo onClick={() => switchView('ov')} title="Zur Übersicht" />
        <Tabs>
          <Tab $active={currentView === 'ov'} onClick={() => switchView('ov')}>
            Übersicht
          </Tab>
          <Tab
            $active={currentView === 'wb'}
            onClick={() => switchView('wb')}
            disabled={cards.length === 0}
          >
            <Pen>✎</Pen> Workboard
          </Tab>
          <Tab
            $active={currentView === 'todo'}
            onClick={() => switchView('todo')}
          >
            To-do Liste
          </Tab>
        </Tabs>
      </HdrLeft>
    </HeaderBar>
  );
};

export default Header;
